<template>
  <div class="steps">
    <div class="steps-item_container">
      <template v-for="(item, index) in steps">
        <div :key="index" class="steps-item" :class="{ 'steps-item_active' : index + 1 <= value }">
          <div class="steps-line" />
          <div class="steps-wrapper">
            <div class="steps-number">{{ index + 1 | numberFilter }}</div>
            <div class="steps-title">{{ item }}</div>
          </div>
        </div>
      </template>
      <div class="steps-item steps-last" :class="{ 'steps-item_active' : value === steps.length }">
        <div class="steps-line" />
        <!-- <div class="steps-wrapper"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    numberFilter(value) {
      return value >= 10 ? value : `0${value}`
    }
  },

  props: {
    value: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {

    }
  }
}
</script>

<style lang='scss' scoped>
$blue: #417EF7;
$step-item-width: 44px;

.steps {
    position: relative;
    max-width: 70vw;
    .steps-item_container {
        position: relative;
        z-index: 3;
        display: flex;
        .steps-item {
            flex: 1;
            display: flex;
            .steps-line {
                flex: 1;
                position: relative;
                top: 22px;
                height: 3px;
                transform: translateY(-50%);
                background-color: #E6E6E6;
            }
            .steps-wrapper {
                width: $step-item-width;
                .steps-number {
                    width: $step-item-width;
                    height: $step-item-width;
                    font-size: 22px;
                    color: #fff;
                    line-height: $step-item-width;
                    text-align: center;
                    border-radius: 50%;
                    background-color: #D3D6DB;
                }
                .steps-title {
                    display: flex;
                    justify-content: center;
                    font-size: 22px;
                    color: #D3D6DB;
                    text-align: center;
                    white-space: nowrap;
                    margin: 9px 0 0;
                }
            }
        }
        .steps-last {
            margin: 0 -$step-item-width 0 0;
            .steps-line {
                margin: 0 $step-item-width 0 0;
            }
        }
        .steps-item_active {
            .steps-line {
                background-color: $blue;
            }
            .steps-wrapper {
                .steps-number {
                    background-color: $blue;
                }
                .steps-title {
                    color: $blue;
                }
            }
        }
    }
}
</style>
